import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const HowToStudyService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.HOW_TO_STUDY, null, wait).then((data) => {
            callback(data);
        });
    },
    /*ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.HOW_TO_STUDY + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },*/
};